module.exports = __webpack_public_path__ + "static/media/hand-1917895_1280.fb3c8fa3.png";